import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    toast.dismiss();
    toast.error("Please login to continue");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
